/**
 * Created by Mark on 06/04/2017.
 */

import React  from 'react';
import DataTableComponent from '../tables/table.component.js';
import AssignmentsService from '../../services/assignment-services.js';
import AssignmentStore from '../../store/assignment-store.js';
import { FormattedMessage } from 'react-intl';

export default class TeacherTable extends React.Component {


    constructor(props){
        super();
        this.props = props;
        this.state = {homework:[] , additionalButtons:this.props.additionalButtons || false}
    }


    componentDidMount() {
        AssignmentsService.getAllHomework();
    }

    componentWillMount(){
        AssignmentStore.on("CHANGE" , () => {
            this.setState({
                homework:AssignmentStore.allHomework
            });
        });
    }

    rebuildSchema() {

        let schema = {
            type: 'object',
            properties: {
                language:{
                    type: 'dom',
                    translationsID: 'ui-492',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Language',
                    id: 'language'
                },
                profileLink: {
                    type: 'link',
                    translationsID: 'ui-14',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Name',
                    id: 'profileLink'
                },

                totalStudents:{
                    type: 'String',
                    translationsID: 'ui-776',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Total Students',
                    id: 'totalStudents'
                },
                totalComplete:{
                    type: 'String',
                    translationsID: 'ui-772',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Total Completed',
                    id: 'totalComplete'
                },
                totalIncomplete:{
                    type: 'String',
                    translationsID: 'ui-773',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Total InCompleted',
                    id: 'totalIncomplete'
                },
                setDTS:{
                    type: 'dom',
                    translationsID: 'ui-483',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Set',
                    id: 'setDTS'
                },
                dueDTS:{
                    type: 'dom',
                    translationsID: 'ui-853',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Due',
                    id: 'dueDTS'
                }
            },
            data: this.state.homework
        };

        return schema;
    }

    handelAddUser(){

    }

    render(){
        return <DataTableComponent disableChangeCols additionalButtons={this.state.additionalButtons} schema={this.rebuildSchema([])} ref={(object) => { this.table = object; } }  />
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/assignment-table.js